import React, { useState } from "react";

// @mui/material components

// @mui/icons-material
import Face from "@mui/icons-material/Face";

// core components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import { OpcionSiNo, PopUpResult } from "../othelloConstantes.jsx";
import Button from "../components/Button.jsx";
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import ImageUpload from "../components/ImageUpload.jsx";
import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";
import OthelloEdit from '../componentsothello/OthelloEdit.jsx';

export default function Importacion({ ...props }) {


    const [loading, setLoading] = React.useState(true);

    const [alert, setalert] = React.useState(null);

    const [coordenadasfinal, setcoordenadasfinal] = useState("");   

    React.useEffect(() => {

        setLoading(false);
        //getDataPage();
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const ImportacionClick = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formimport');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        fetch('api/Data/GrabarImportacion', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {
            if (res)
                setalert(PopUpResult.OK);
            else
                setalert(PopUpResult.KO);
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const CoordenadasClick = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formkml');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        fetch('api/Data/GetCoordenadasKml', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {
            setcoordenadasfinal(res.resul);

        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }


    const onClosePopUpResult = () => {
        setalert(null);
    }

    //RENDERIZADO DE LA PAGINA    

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            <Grid item xs={12}>
                <OthelloTituloPanelData icon="face" titulo="Importacion" margentop={4}>
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        <form id="formimport" >
                            <Grid container>
                                <Grid item xs={12} sm={12}>
                                    <Button color="facebook" onClick={ImportacionClick}>Importar</Button>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={12} sm={2}>
                                    <OthelloComboBox label='Modo Actualizacion' fieldname="actualizacion" items={OpcionSiNo} currentvalue="0" />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <legend>Seleccionar fichero Excel</legend>
                                    <ImageUpload
                                        id="ficheroexcel" name="ficheroexcel"
                                        imageUrl=""
                                        addButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        changeButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        removeButtonProps={{
                                            color: "danger",
                                            round: true
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                </OthelloTituloPanelData>
            </Grid>

            <Grid item xs={12}>
                <OthelloTituloPanelData icon="face" titulo="Kml Coordenadas" margentop={4}>                    
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        <form id="formkml" >
                            <Grid container>
                                <Grid item xs={12} sm={12}>
                                    <Button color="facebook" onClick={CoordenadasClick}>Obtener</Button>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={12} sm={2}>
                                    <legend>Seleccionar fichero Kml</legend>
                                    <ImageUpload
                                        id="ficherokml" name="ficherokml"
                                        imageUrl=""
                                        addButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        changeButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        removeButtonProps={{
                                            color: "danger",
                                            round: true
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <legend>Resultado Lectura Kml</legend>
                                    <OthelloEdit label="" currentvalue={coordenadasfinal} rows="30" />                                    
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>
    );
}